/**
 * Triggers a browser download from a URL without opening a new tab or in browser
 * Fetches the file as a blob to force download behavior regardless of Content-Type
 * @param url - The URL to download from (typically a signed S3 URL)
 * @param filename - Optional filename to suggest for the download
 */
export const downloadFromUrl = async (url: string, filename?: string): Promise<void> => {
  try {
    // Fetch the file as a blob to force download behavior
    // This prevents the browser from opening text/plain, PDFs, images, etc.
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to download file: ${response.statusText}`);
    }

    const blob = await response.blob();

    // Create a blob URL from the fetched data
    const blobUrl = window.URL.createObjectURL(blob);

    // Create and click the download link with the blob URL
    const link = document.createElement("a");
    link.href = blobUrl;
    if (filename) {
      link.download = filename;
    }
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Clean up the blob URL to free memory
    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Error downloading file:", error);
    // Fallback to direct link if fetch fails (e.g., CORS issues)
    // This may still open in browser for some content types
    const link = document.createElement("a");
    link.href = url;
    if (filename) {
      link.download = filename;
    }
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
